import { PERSIST_STORE_NAME } from 'Constants/app.constant'
import rootReducer from './rootReducer'
import storage from './storage'
import { configureStore } from '@reduxjs/toolkit'
import { createTransform, persistReducer, persistStore } from 'redux-persist'

const middleware = []

const elementsBlacklist = createTransform(
  (state) => ({ ...state, liquid: undefined }),
  (state) => state,
  { whitelist: ['elements'] }
)

const PERSIST_VERSION = '1_1_0';

const persistConfig = {
  key: `${PERSIST_STORE_NAME}-${PERSIST_VERSION}`,
  keyPrefix: '',
  storage,
  timeout: null,
  whitelist: ['auth', 'elements'],
  transforms: [elementsBlacklist],
}

const store = configureStore({
  reducer: persistReducer(persistConfig, rootReducer()),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middleware),
  devTools: process.env.NODE_ENV === 'development'
})

store.asyncReducers = {}

export const persistor = persistStore(store)

export const injectReducer = (key, reducer) => {
  if (store.asyncReducers[key]) {
    return false
  }
  store.asyncReducers[key] = reducer
  store.replaceReducer(persistReducer(persistConfig, rootReducer(store.asyncReducers)))
  persistor.persist()
  return store
}

export default store
